<template>
  <div style="height: calc(100vh - 120px);">
    <listToolbar :toolbar="toolbar" @toolTap="toolTap" @addTap="addTap" />
    <listTable
      :list="list"
      :page="page"
      :loading="loading"
      :total="total"
      :pageSize="pageSize"
      :columns="columns"
      @page-change="pageChange" />
    <el-drawer v-model="formDrawerVisible" size="30%" :title="typeForm === 'add'? '添加' : '修改'">
      <div v-if="formDrawerVisible" style="padding-left: 16px; padding-right: 16px;">
        <Form :columns="addColumns" :type="typeForm" @submit="submit" />
      </div>
    </el-drawer>
    <el-drawer v-model="formDrawerVisible2" size="30%" title="详情">
      <div v-if="formDrawerVisible2" style="padding-left: 16px; padding-right: 16px;">
        <formSee :columns="addColumnsDet" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { userRechargeDel, userRechargeList, userRechargeSubmit } from '@/apis/common'
import ListToolbar from '@/components/system/listToolbar.vue'
import listTable from '@/components/system/listTable.vue'
import Form from '@/components/system/form.vue'
import formSee from '@/components/system/formSee.vue'

export default {
  name: 'income',
  components: { formSee, Form, listTable, ListToolbar },
  data() {
    return {
      info: JSON.parse(sessionStorage.getItem('user')) || {},
      page: 1,
      pageSize: 15,
      total: 0,
      loading: false,
      formData: {
        name: '',
        start_date: '',
        end_date: ''
      },
      toolbar: [
        {type: 'input', label: '学生姓名', model: 'name', value: ''},
        {type: 'date', label: '开始时间', model: 'start_date', value: ''},
        {type: 'date', label: '结束时间', model: 'end_date', value: ''},
        {type: 'button', label: '搜索', icon: 'el-icon-search', def: 'default', key: 'search'},
        {type: 'button', label: '添加', def: 'primary',key: 'add'}
      ],
      typeForm: 'add',
      formDrawerVisible: false,
      formDrawerVisible2: false,
      addColumns: [
        {label: '学生用户', prop: 'user_id', value: '', type: 'student',  options: []},
        {label: '有效期', prop: 'validity', linkage: 'one', main: true, type: 'select', value: '',options: [
            {label: '永久', value: 0},
            {label: '限期', value: 1}
          ]},
        {label: '充值金额', prop: 'recharge_money', value: '', type: 'input'},
        {label: '赠送金额', prop: 'gave_money', value: '', type: 'input'},
        {label: '收款方式', prop: 'pay_type', value: '', type: 'select', options: [
            {label: '微信', value: 1},
            {label: '支付宝', value: 2},
            {label: '现金', value: 3},
            {label: '转账', value: 4},
            {label: '其他', value: 5},
            {label: '余额', value: 6},
          ]},
        {label: '充值日期', prop: 'recharge_date', value: '', type: 'date'},
        {label: '到期日期', prop: 'end_date',  linkage: 'one', linkageValue: '1', value: '', type: 'date'},
        {label: '备注', prop: 'note', type: 'textarea', value: ''},
      ],
      list: [],
      columns: [
        {label: '充值记录ID', prop: 'id', width: 100, type: 'text'},
        {label: '充值学生姓名', prop: 'name', width: 100, type: 'text'},
        {label: '充值学生电话', prop: 'phone', width: 100, type: 'text'},
        {label: '充值金额', prop: 'recharge_money', width: 100, type: 'text'},
        {label: '赠送金额', prop: 'gave_money', width: 100, type: 'text'},
        {label: '收款方式', prop: 'pay_type', width: 80, type: 'tag',  arr: [
            {key: 1,type: 'success', label: '微信'},
            {key: 2,type: 'success', label: '支付宝'},
            {key: 3,type: 'success', label: '现金'},
            {key: 4,type: 'success', label: '转账'},
            {key: 5,type: 'success', label: '其他'},
            {key: 6,type: 'success', label: '余额'},
          ]},
        {label: '有效期', prop: 'validity', width: 80, type: 'tag',  arr: [
            {key: 0,type: 'success', label: '永久'},
            {key: 1,type: 'success', label: '限期'},
          ]},
        {label: '到期日期', prop: 'end_date', width: 150, type: 'text'},
        {label: '充值日期', prop: 'recharge_date', width: 150, type: 'text'},
        {label: '添加时间', prop: 'created_at', width: 150, type: 'text'},
        {label: 'note', prop: 'note', width: 150, type: 'text'},
        {label: '操作', width: 260, type: 'but', arr: [
            {type: 'default', icon: 'el-icon-document', label: '查看', onClick: (row) => this.seeDetails(row)},
            {type: 'danger', icon: 'el-icon-delete', label: '删除', onClick: (row) => this.del(row)}
          ]}
      ],
      addFormData: {},
      addColumnsDet: [
        {label: '充值学生姓名', prop: 'name', type: 'input', value: ''},
        {label: '充值学生电话', prop: 'phone', type: 'input', value: ''},
        {label: '充值金额', prop: 'recharge_money', type: 'input', value: ''},
        {label: '赠送金额', prop: 'gave_money', type: 'input', value: ''},
        {label: '销售员姓名', prop: 'saler_name', type: 'input', value: ''},
        {label: '收款方式', prop: 'pay_type', type: 'select',value: '' , options: [
            {label: '微信', value: 1},
            {label: '支付宝', value: 2},
            {label: '现金', value: 3},
            {label: '转账', value: 4},
            {label: '其他', value: 5},
            {label: '余额', value: 6},
          ]},
        {label: '有效期', prop: 'validity', type: 'select',value: '' , options: [
            {value: 0,label: '永久'},
            {value: 1,label: '限期'},
          ]},
        {label: '到期日期', prop: 'end_date', type: 'date', value: ''},
        {label: '充值日期', prop: 'recharge_date', type: 'date', value: ''},
        {label: '添加时间', prop: 'created_at', type: 'date', value: ''},
        {label: '备注', prop: 'note', type: 'input', value: ''},
      ]
    }
  },
  mounted() {
    this.getSchoolMoneyList()
  },
  methods: {
    // 查看
    seeDetails(row) {
      this.addColumnsDet.forEach(item => {
        item.value = row[item.prop]
      })
      this.formDrawerVisible2 = true
    },
    // 删除
    del(row) {
      this.addFormData = row
      this.$confirm('确定要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userRechargeDel({
          admin_id: this.info.id,
          school_id: this.info.agency_school_id,
          recharge_id: row.id
        }).then(res => {
          this.$message.success('删除成功')
          this.getSchoolMoneyList()
        })
      }).catch(() => {})
    },
    // 修改
    modify(row) {
      this.addFormData = row
      this.typeForm = 'edit'
      this.addColumns.forEach(item => {
        item.value = row[item.prop]
      })
      this.formDrawerVisible = true
    },
    submit(e,n) {
      let form = {
        admin_id: this.info.id,
        school_id: this.info.agency_school_id,
        ...e
      }
      userRechargeSubmit(form).then(res => {
        this.formDrawerVisible = false
        this.$message.success('操作成功')
        this.getSchoolMoneyList()
      })
    },
    addTap() {
      this.addColumns.forEach(item => {
        item.value = ''
      })
      this.formDrawerVisible = true
      this.typeForm = 'add'
    },
    // 分页
    pageChange(e) {
      this.page = e
      this.getSchoolGoodsList()
    },
    toolTap(data) {
      this.formData = data
      this.page = 1
      this.getSchoolMoneyList()
    },
    getSchoolMoneyList() {
      this.loading = true
      userRechargeList({
        admin_id: this.info.id,
        school_id: this.info.agency_school_id,
        page: this.page,
        pagesize: this.pageSize,
        ...this.formData
      }).then(res => {
        this.total = res.data.data.count
        this.list = res.data.data.list
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
